module.exports = __webpack_public_path__ + "img/py.444e3f2a.jpg";